<template>
    <v-container grid-list-md fluid>
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row class="py-1" style="flex-wrap: nowrap">
                <v-col class="d-flex justify-start align-center">
                    <v-btn-back @click.stop="$router.push({ name: 'company-scopes' })"/>
                </v-col>
                <v-col class="d-flex justify-end align-center">
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        @click="updateScope()"
                        size="small"
                        :disabled="validDisabled"
                    >
                        {{ patternId ? "Modifier" : "Créer" }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-row no-gutters class="default_card_admin">
            <v-col cols="12">
                <Scope
                    ref="refScope"
                    v-model="scopeSync"
                    v-model:id="scopeId"
                    @validName="validName = $event"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import { User } from "../../store/store";
import { Component, Vue, toNative, Watch, Model, Ref } from "vue-facing-decorator";
import COMPANY_SCOPE from "../../graphql/CompanyScope.gql"
import Scope from "../companyScope/Scope.vue";

@Component({
    components: {
        Scope
    },
})
export class CompanyScopeEdition extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Model({ type: String, default: "", name: "name" }) nameSync: string;

    @Ref() readonly refScope!: any;

    validName = false;
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get validDisabled() {
        if(!this.validName) {
            return true
        }
        if(this.readonly) {
            return true
        }
        return false
    }

    get accountingCompanyId() {
        return this.currentUser.company.id;
    }

    get isRootProfile() {
        if (this.currentUser.isRoot) {
            return true;
        }
        return false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get profile() {
        return this.$store.state.user.profile;
    }

    get patternId() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        }
        return "";
    }

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
        }
    }

    readonly = false;

    isReadOnly(accountingCompany, accountingCompanyOwner) {
        if (accountingCompany == null && accountingCompanyOwner?.id !== this.accountingCompanyId) {
            this.readonly = true;
        }
    }

    beforeMount() {
        this.scopeId = this.patternId as any;
    }

    async mounted(){
        if(this.scopeId) {
            const result = await this.$apollo.query({
                query: COMPANY_SCOPE,
                variables: {
                    id: this.scopeId,
                },
            });
            const scope = result.data.companyScope
            this.isReadOnly(scope.accountingCompany, scope.accountingCompanyOwner)
        }
    }

    async updateScope() {
        if (this.refScope) {
            await this.refScope.upsert();
            this.$router.push({ name: 'company-scopes' })
        }
    }
}

export default toNative(CompanyScopeEdition);
</script>